import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "address-dropmark",
  "use": "address-dropmark-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"address-dropmark\"><path fill-rule=\"evenodd\" d=\"M5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7S5 5.13 5 9Zm4.5 0a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol